<div class="ui-g">
  <div class="trial-section" [ngClass]="trial.isCalendar ? 'ui-g-12' : 'ui-g-6'" 
  *ngIf="!trial.isCalendar && trial.trialStatus === appointmentRequestTrialStatus.trial"
  >
    <div class="remaining-period">
      <span class="font-600">You have</span> <strong class="ml-1">{{ trial.dateDiffrence }} days remaining.</strong>
      <a class="hover-underline font-600 pointer anchor-green" id="intercom-chat" (click)="toggleHighlight()" [ngClass]="{ highlight: selected }" href="javascript:void(0)" #intercomBtn> Get in touch</a>
    </div>
    <ng-container *ngIf="trial.reqRecieved > 4">
      <div class="mt-2 font-12">
        No. of requests received: <strong>{{ trial.reqRecieved }}</strong>
      </div>
      <div class="font-12">
        No. of appointments booked: <strong>{{ trial.apptBooked }}</strong>
      </div>
    </ng-container>
  </div>

  <div class="trial-section" 
  *ngIf="trial.isCalendar && trial.trialStatus === appointmentRequestTrialStatus.trial"
   [ngClass]="trial.isCalendar ? 'calendar-trial' : ''">
    <div class="d-flex flex-between mb-2">
      <div class="font-14">Days remaining: <strong>{{ trial.dateDiffrence }}</strong></div>
      <a class="hover-underline upgrade anchor-green" id="intercom-chat" (click)="toggleHighlight()" [ngClass]="{ highlight: selected }" href="javascript:void(0)" #intercomBtn
        ><i class="fal fa-unlock mr-1"></i> Upgrade now</a
      >
    </div>
    <ng-container *ngIf="trial.reqRecieved > 4">
      <div>
        Requests received: <strong>{{ trial.reqRecieved }}</strong>
      </div>
      <div> 
        Appointments booked: <strong>{{ trial.apptBooked }}</strong>
      </div>
    </ng-container>
  </div>

  <div class="trial-section-warning" [ngClass]="trial.isCalendar ? 'ui-g-12' : 'ui-g-6'" 
  *ngIf="trial.trialStatus === appointmentRequestTrialStatus.expired">
    <div class="d-flex mb-2">
      <div><i class="fal fa-exclamation-triangle"></i></div>
      <div class="pl-2">
        <span class="font-bold">
          To get full access,
          <a class="hover-underline upgrade" id="intercom-chat" (click)="toggleHighlight()" [ngClass]="{ highlight: selected }" href="javascript:void(0)" #intercomBtn>Upgrade now</a>
        </span>
        <div class="mt-2 font-12">
          Your customers can no longer request appointments.
        </div>
        <ng-container *ngIf="trial.reqRecieved > 4">
          <div class="mt-3 font-12">
            Requests received: <strong>{{ trial.reqRecieved }}</strong>
          </div>
          <div class="font-12">
            Appointments booked: <strong>{{ trial.apptBooked }}</strong>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
